import React, { useEffect, useState } from "react";

import {
  Text,
  Toast,
  Input,
  EditModal,
  ConfirmAlert,
  GroupInfoBox,
  AddItemButton,
  DeleteAlertComponent,
} from "components";

import { useFlag } from "hooks";
import { changeArrayAt } from "utils";
import { colors, patterns, sizes, strings } from "assets/constants";
import { View } from "react-native";
import css from "styles";

export default function Emails(props: {
  emails: string[];
  onChange: (emails: string[]) => void;
  disabled?: boolean;
}) {
  const { emails, onChange, disabled } = props;
  const [itemsState, setItemsState] = useState<Array<string>>(emails);
  useEffect(() => {
    setItemsState(emails);
  }, [emails]);

  const [indexToEdit, setIndexToEdit] = useState<number | null>(null);
  const { flg: modal, on: showModal, off: hideModal } = useFlag();
  const { flg: alert, on: showAlert, off: hideAlert } = useFlag();

  const [field, setField] = useState("");

  const resetForm = () => {
    setIndexToEdit(null);
    setField("");
  };

  const _onAdd = () => {
    field && onChange(emails ? [...emails, field] : [field]);
    resetForm();
  };

  const _onEdit = () => {
    const tmp =
      typeof indexToEdit === "number" &&
      changeArrayAt(itemsState, indexToEdit, field);
    tmp && onChange(tmp);
  };

  const _onDelete = (close: () => void) => {
    const tmp =
      typeof indexToEdit === "number" && changeArrayAt(itemsState, indexToEdit);
    tmp && onChange(tmp);
    resetForm();
    close();
  };

  const _onConfirm = () => {
    if (!field) {
      Toast.error({ message: strings.fill_all_fields });
      return;
    }

    if (!field.match(patterns.email)) {
      Toast.error({ message: strings.invalid_email });
      return;
    }
    indexToEdit === null ? _onAdd() : _onEdit();
    resetForm();
    hideModal();
  };

  const _onCancel = () => {
    resetForm();
    hideModal();
  };

  return (
    <>
      <View style={css.responsiveListContainer}>
        {itemsState?.length > 0 ? (
          itemsState?.map((email: string, key: number) => {
            return (
              <View key={String(key)} style={css.responsiveBoxContainer}>
                <GroupInfoBox
                  disabled={disabled}
                  key={String(key)}
                  onEdit={() => {
                    setIndexToEdit(key);
                    setField(email);
                    showModal();
                  }}
                  onDelete={() => {
                    setIndexToEdit(key);
                    showAlert();
                  }}
                  title={email}
                  icon={{ name: "mail" }}
                />
              </View>
            );
          })
        ) : (
          <Text
            size="sm"
            color={colors.textColorGray}
            style={{ marginBottom: sizes.space / 2 }}
          >
            {strings.no_customer_email}
          </Text>
        )}
      </View>
      {!disabled && (
        <AddItemButton onPress={showModal} title={strings.add_new_email} />
      )}

      <EditModal
        visible={modal}
        onCancel={_onCancel}
        onConfirm={_onConfirm}
        renderForm={() => {
          return (
            <>
              <Input
                onChangeText={setField}
                value={field}
                placeholder={strings.insert_email}
                icon={{ name: "mail" }}
                keyboardType="email-address"
                autoFocus
              />
            </>
          );
        }}
      />

      <ConfirmAlert
        force
        show={alert}
        hide={hideAlert}
        renderContent={(close) => (
          <DeleteAlertComponent
            removeLoading={false}
            remove={() => _onDelete(close)}
            cancel={close}
          />
        )}
      />
    </>
  );
}
